import React from "react";
import { Navigate, useParams } from "react-router";
import { useSearchParams } from "react-router-dom";
import { Context } from "../context/ContextProvider";
import jwt_decode from "jwt-decode";
import { Button, CircularProgress, Paper, Typography } from "@mui/material";
import { Divider, Grid } from "semantic-ui-react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { Box } from "@mui/system";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { useNavigate } from "react-router-dom";

function CurrentOrder(props) {
  // const {orderId} = useParams();
  // let [searchParams, setSearchParams] = useSearchParams();

  const {
    categories,
    items,
    setItems,
    addOrder,
    setOrders,
    orders,
    newList,
    setNewList,
    amountOfItemsInCart,
    handleAddProduct,
    cartItmes,
    setCartItems,
    handleRemoveProduct,
    totalPrice,
    token,
    values,
    setValues,
  } = React.useContext(Context);
  let navigate = useNavigate();

  // const price = totalPrice;

  const query = new URLSearchParams(window.location.search);
  const orderId = query.get("orderId");
  const dataKey = localStorage.getItem("dataKey");
  const [isPay, setIsPay] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  // const [itemNo, setItemNo] = React.useState(
  //   Math.floor(Math.random() * 1000000000)
  // );

  React.useEffect(() => {
    // console.log("totalPrice: ", localStorage.getItem("AllData"));
    // console.log("totalPrice: ", localStorage.getItem("Price"));
    // console.log(
    //   "time: ",
    //   localStorage.getItem("ChoosePay")
    // );
    // const dataKey = localStorage.getItem('dataKey');

    const getOrderId = () => {
      fetch(
        `https://fatora-sa.herokuapp.com/api/v1/push/get-order-id?orderId=${orderId}`,
        {
          method: "GET",
          headers: {
            "Content-type": "application/json",
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          // console.log("data: ", data);
          if (
            (data.resultCode === 0 &&
              data.result.order.status === "CAPTURED") ||
            (data.resultCode === 0 &&
              data.result.order.status === "3DS_ENROLL_INITIATED")
          ) {
            // console.log("success ...");
            // // console.log("data: ", dataKey);
            // console.log("orders: ", JSON.parse(localStorage.getItem("Order")));
            // console.log("user: ", isPay);
            // setIsLoading(false);
            setIsPay(true);
            setIsLoading(false);
            fetch(`https://fatora-sa.herokuapp.com/api/v1/orders/create`, {
              method: "POST",
              headers: {
                "Content-type": "application/json",
              },
              body: JSON.stringify({
                orders: JSON.parse(localStorage.getItem("Order")).map(
                  (order) => ({
                    productId: order._id,
                    name: order.name,
                    unit: order.unit,
                    qty: order.qty,
                    basicPrice: order.basicPrice,
                  })
                ),
              }),
            })
              .then((res) => res.json())
              .then((data) => {
                console.log("jfklsadj");
                fetch(
                  `https://fatora-sa.herokuapp.com/api/v1/invoices/create-casheir-invoice`,
                  {
                    method: "POST",
                    headers: {
                      "Content-type": "application/json",
                    },
                    body: JSON.stringify({
                      itemNo: orderId,
                      time: new Date()
                        .toTimeString()
                        .replace(/^[^:]*([0-2]\d:[0-5]\d).*$/, "$1"),
                      date: new Date().toISOString().split("T")[0],
                      title: "Atr",
                      user_id: jwt_decode(localStorage.getItem("Token")).user
                        ._id,
                      orders: data._id,
                      company_id: "62160bc81c5ceec125780794",
                      token_id: {
                        _id: "638a8cc11dbde0961bb169b9",
                        type: "ios",
                        data: "27b6fbf996b28fde2599dcbe09a2d532da8dfaa2a14cdee96a13249bc6930325",
                        app: "cashier",
                        __v: 0,
                      },
                      paymentType: localStorage.getItem("ChoosePay"),
                      price: localStorage.getItem("Price"),
                      isShipped: false,
                      isDelivered: false,
                      orderId: orderId,
                    }),
                  }
                )
                  .then((res) => res.json())
                  .then((d) =>
                    // console.log("data: ", { lastInoice: d }) &
                    d.message !== "existent"
                      ? localStorage.setItem("LastInvoice", JSON.stringify(d)) &
                        localStorage.setItem("CountCart", 0) &
                        localStorage.removeItem("Order") &
                        setCartItems([])
                      : null
                  )

                  .catch((error) => console.log("error: ", error.message));
              })
              .catch((error) => console.log("error: ", error.message));
          } else {
            setIsLoading(false);
            // setIsPay(false);
            // setIsLoading(false);
          }

          // window.location.replace(data.result.checkoutData.postUrl)
        })
        .catch(() => (error) => console.log("error: ", error.message));
    };
    getOrderId();
  }, []);

  return (
    <>
      <div style={{ paddingTop: 100, height: 800 }}>
        {/* CurrentOrder:
        {isLoading === false
          ? isPay
            ? `تم الدفع بنجاح ${orderId}`
            : "Your order Cancel Please try again later"
          : "loading ..."} */}
        {/* <Grid container>
          <Grid item xs={12}> */}

        {isLoading === true ? (
          <Box style={{ textAlign: "center" }}>
            <CircularProgress style={{ color: "gray" }} />
          </Box>
        ) : isPay === false ? (
          <Paper
            sx={{
              margin: 3,
              height: 230,
              textAlign: "center",
              padding: 5,
              boxShadow: "0 1px 6px 1px red",
            }}
          >
            <HighlightOffIcon
              fontSize="large"
              style={{ color: "red", fontSize: 40 }}
            />
            <Typography variant="body1" pb={0} style={{ color: "red" }}>
              عفواً لم تتم عملية الدفع بنجاح
            </Typography>
            <Typography variant="body2" pb={3} style={{ color: "gray" }}>
              حاول مرة أخرى
            </Typography>
            {/* <Divider /> */}
            {/* <Typography
              variant="body1"
              pb={0}
              pt={3}
              style={{ color: "black" }}
            >
              المبلغ المدفوع:{" "}
              <strong>{localStorage.getItem("Price")} ريال</strong>
            </Typography> */}
            <Typography variant="caption" pb={0} style={{ color: "black" }}>
              تواصل معنا إذا واجهتك مشكلة: <strong>0555645556</strong>
            </Typography>
            {/* <Divider style={{ borderStyle: "dotted", borderRadius: 2 }} /> */}
          </Paper>
        ) : (
          <Paper
            sx={{
              margin: 3,
              height: 250,
              textAlign: "center",
              padding: 5,
              boxShadow: "0 1px 6px 1px green",
            }}
          >
            <TaskAltIcon style={{ color: "green", fontSize: 40 }} />

            <Typography variant="body1" pb={0} style={{ color: "green" }}>
              شكراً لطلبك عبر متجرنا
            </Typography>
            <Typography variant="caption" pb={0} style={{ color: "gray" }}>
              رقم الطلب: <strong>{orderId}</strong>
            </Typography>
            {/* <Divider /> */}
            <Typography
              variant="body1"
              pb={0}
              pt={3}
              style={{ color: "black" }}
            >
              المبلغ المدفوع:{" "}
              <strong>{localStorage.getItem("Price")} ريال</strong>
            </Typography>
            <Typography>
              <Button
                // variant="body1"
                variant="text"
                pb={0}
                pt={3}
                style={{ color: "black", textDecorationLine: "underline" }}
                onClick={
                  () =>
                    navigate(`/order/${orderId}`, {
                      state: {
                        invoice: JSON.parse(
                          localStorage.getItem("LastInvoice")
                        ),
                        //...values
                      },
                    })
                  // console.log(
                  //   "data last invoice: ",
                  //   JSON.parse(localStorage.getItem("LastInvoice"))
                  // )
                }
              >
                تفاصيل الفاتورة
              </Button>
            </Typography>
            <Typography variant="caption" pb={0} style={{ color: "black" }}>
              تواصل معنا إذا واجهتك مشكلة: <strong>{orderId}</strong>
            </Typography>
            {/* <Divider style={{ borderStyle: "dotted", borderRadius: 2 }} /> */}
          </Paper>
        )}
        {/* </Grid>
        </Grid> */}
      </div>
    </>
  );
}

export default CurrentOrder;
